import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

export function UserField({name, type, setField, error, id}){
	let localError = error[id]
	return (
		<TextField
			margin="normal"
			fullWidth
			error={Boolean(localError)}
			label={name}
			placeholder={name}
			required={true}
			onChange={(evt) => {setField(evt.target.value);}}
			helperText={localError}
			type={type}
			id={id}
		/>
	)
}

export function UsernameField({setField, error, id="username"}){
	return (
		<UserField name="Username" type="text" setField={setField} error={error} id={id} />
	)
}

export function PasswordField({setField, error, id="password", name="Password"}){
	return (
		<UserField name={name} type="password" setField={setField} error={error} id={id} />
	)
}

export function EmailField({setField, error, id="email"}){
	return (
		<UserField name="Email" type="email" setField={setField} error={error} id={id}/>	
	)
}

export function Submit({onSubmit, error, name}){
	// detail is the generic name returned by DRF for formwide issues
	let localError = error["detail"];
	return (
		<>
			<Button
				variant="contained"
				sx={{mt:1}}
				fullWidth
				onClick={() => {onSubmit();}}
			>
				{name}
			</Button>
			{localError ?
				<Typography color="error">{localError}</Typography> : <></>}
		</>
	)
}
